import FilmQuizBrokenHeartSvg from 'src/components/svg/FilmQuizBrokenHeartSvg';
import styled from 'src/lib/styles/css';

//#region [Props]
type FinishedQuizProps = {
	questionNumber: number;
};
//#endregion

export default function FinishedQuiz({questionNumber}: FinishedQuizProps) {
    let text;

    if (questionNumber === 3)
    {
        text = "Du bør se mer film!";
    }
    else if (questionNumber < 6)
    {
        text = "Kom igjen, du kan bedre!";
    }
    else if (questionNumber < 10)
    {
        text = "Bra! Kan du klare 10?";
    }
    else if (questionNumber < 20)
    {
        text = "Veldig bra! Du er flink!";
    }
    else if (questionNumber < 30)
    {
        text = "Imponerende! Du kan mye om film!";
    }
    else if (questionNumber < 40)
    {
        text = "Fantastisk! Du er en Terminator!";
    }
    else if (questionNumber < 50)
    {
        text = "Gudeliknende! Vi bøyer oss i støvet!";
    }
    else
    {
        text = "Filmuniversets mester! Skalder bør lage sagn om deg!";
    }

    return (
        <div>
            <SFinishedQuiz>
                <SHeaderNoLives>
                    Du har brukt opp alle livene
                    <div>
                        <FilmQuizBrokenHeartSvg /><FilmQuizBrokenHeartSvg /><FilmQuizBrokenHeartSvg />
                    </div>
                </SHeaderNoLives>
                <div>Du kom til spørsmål {questionNumber}!</div>
                <SCongratulation>
                    {text}
                </SCongratulation>
                <div>Vil du prøve igjen?</div>
            </SFinishedQuiz>
        </div>
    );
}

const SFinishedQuiz = styled.div`
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 20px;
    background-color: #231a41;
    font-weight: bold;
`;

const SHeaderNoLives = styled.div`
    font-size: 16px;
    margin-bottom: 10px;

    div {
        display: flex;
        justify-content: center;

        svg {
            margin: 2px;
            fill: black;
        }
    }
`;

const SCongratulation = styled.div`
    margin-top: 10px;
    margin-bottom: 10px;

    font-size: 24px;
`;
